<template>
	<v-layout style = 'flex: 0 0 auto !important;'>
		<v-btn icon @click.stop.prevent = 'visibility = !visibility' small>
			<v-icon :color = '$store.getters.uiAccentIcon' small>delete_outline</v-icon>
		</v-btn>
		<dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator'>
			<template v-slot:title>{{user.name}} {{user.lastname}}</template>
			<template v-slot:content>
				<div class = 'py-3'>Отключить пользователя от проекта?</div>
			</template>
			<template v-slot:action>
				<v-btn class = 'px-0 red--text text--darken-2' :loading = 'indicator' block depressed @click = 'deleteProjectPerson'>Отключить</v-btn>
			</template>
		</dialog-generic>
	</v-layout>
</template>

<script>
	import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

	export default {
		name: 'UserProjectDeleteMenu',
		props: ['data', 'postAction', 'project'],
		components: {'dialog-generic': DialogGeneric},
		data() {
			return {
				visibility: false,
				user: this.data,
				indicator: false
			}
		},
		methods: {
			deleteProjectPerson() {
				this.indicator = true;
		        let requestHeaders = {
		          'Content-Type': 'application/json;charset=UTF-8',
		          'Authorization': 'Bearer ' + this.$store.getters.userToken
		        }
			    this.$http.patch(this.$store.getters.endpoint + '/db/project/' + this.project.project_id + '/persons', {
				        'login': this.$store.getters.userLogin,
				        'uid': this.user.uid
				    } , {
				        headers: {...this.$store.state.restrictedHeaders,...requestHeaders
				    }
			    }).then( (r) => {
			        let response = r.body;
			        if (response.result) {
						this.indicator = false;
						this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'delete',
                                target: 'project_user'
                            },
                            once: false
                        })
			            this.postAction('persons');
			            this.visibility = false;
			        } else {
			            console.log(response)
			        }
			    })
			}
		}
	}
</script>